import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  const handleExploreClick = () => {
    navigate('/about');
  };

  // Carousel logic
  const images = [
    '/banner/banner1.jpg',
    '/banner/banner1(1).jpg',
    '/banner/banner1(2).jpg',
  ];
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '100vw',
        aspectRatio: { xs: 'unset', sm: '16 / 9' }, // Remove aspect ratio on xs
        minHeight: { xs: '100vh', sm: 'auto' }, // Fill viewport on mobile
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        overflowX: 'hidden',
        p: 0,
        m: 0,
      }}
    >
      {/* Background Image Carousel */}
      {images.map((img, idx) => (
        <Box
          key={img}
          component="img"
          src={img}
          alt="Hero Background"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            zIndex: 1,
            pointerEvents: 'none',
            userSelect: 'none',
            opacity: idx === current ? 1 : 0,
            transition: 'opacity 1s ease',
          }}
        />
      ))}
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0,0,0,0.45)',
          zIndex: 2,
        }}
      />
      {/* Centered Content */}
      <Container
        sx={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: { xs: '100vh', sm: 'auto' }, // Ensure container fills height on mobile
          textAlign: 'center',
          color: '#fff',
          py: { xs: 2, sm: 0 },
          px: { xs: 1, sm: 0 },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: '1.5rem', sm: '2.1rem', md: '2.7rem', lg: '3.5rem' },
            mb: { xs: 1, sm: 2 },
            fontFamily: 'Montserrat, Arial, sans-serif',
            color: '#fff',
            letterSpacing: '0.02em',
            opacity: 0,
            animation: 'fadeIn 1.2s ease forwards',
            textShadow: '0 2px 8px rgba(0,0,0,0.7)',
          }}
        >
          Premium FSC-Certified Timber for the World
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 400,
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem', lg: '1.5rem' },
            mb: { xs: 2, sm: 4 },
            color: '#f5f3e7',
            opacity: 0,
            animation: 'fadeIn 1.2s 0.3s ease forwards',
            textShadow: '0 1px 4px rgba(0,0,0,0.7)',
          }}
        >
          Exporting high-quality veneer and plywood directly from Gabon — stockless, sustainable, and global.
        </Typography>
        <Button
          variant="outlined"
          size="large"
          onClick={handleExploreClick}
          sx={{
            borderColor: '#fff',
            color: '#fff',
            px: { xs: 3, sm: 4 },
            py: { xs: 1, sm: 1.2 },
            fontWeight: 700,
            fontSize: { xs: '0.95rem', sm: '1rem', md: '1.15rem' },
            borderRadius: 3,
            letterSpacing: '0.04em',
            background: 'rgba(0,0,0,0.08)',
            transition: 'all 0.25s',
            opacity: 0,
            animation: 'slideUp 1.1s 0.7s cubic-bezier(.23,1.01,.32,1) forwards',
            minWidth: { xs: 120, sm: 160 },
            minHeight: { xs: 40, sm: 48 },
            '&:hover': {
              background: '#fff',
              color: 'primary.main',
              borderColor: '#fff',
              boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
            },
          }}
        >
          Explore More
        </Button>
      </Container>
      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
};

export default Hero; 